import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import FormSettings from '../../../shared/constants/form-settings';
import Notifications from '../../../shared/constants/notifications';

import SVGIcon from '../../../../../../common/react/components/svg-icon';
import DatePicker from 'react-datepicker';

import { coalesce, getUtcString } from '../../../shared/utilities';

import moment from 'moment';
import classNames from 'classnames';

export default class OpenDateSection extends Component {
	constructor (props) {
		super(props);
		
		// Manual binding is required by react-datepicker library!
		this.handleDateChange = this.handleDateChange.bind(this);
	}

	render () {
		const { localization,
			hasScheduleOpening,
			schedule,
			timeInterval
		} = this.props;

		let openGroupClasses = classNames({
			'display' : hasScheduleOpening
		}, 'inputs');

		return (
			<section className='open dates'>
				<input
					ref='openLaterRadio'
					id='open_later_checkbox'
					type='checkbox'
					name='openOptions'
					checked={hasScheduleOpening}
					onChange={this.toggleDate}
				></input>
				<label htmlFor='open_later_checkbox'>
					{localization.substitute('On a specific date')}
				</label>

				<div className={openGroupClasses}>
					<div className='icon input'>
						<SVGIcon name='calendar' />
						{/* we use readOnly to avoid keystrokes */}
						<DatePicker
							ref='openDateInput'
							selected={moment(schedule)}
							onChange={this.handleDateChange}
							showTimeSelect
							timeFormat="hh:mm A"
							timeIntervals={timeInterval}
							timeCaption="time"
							dateFormat="MM/DD/YYYY hh:mm A"
							readOnly={true}
						/>
					</div>
				</div>
			</section>
		);
	}

	handleDateChange = (date) => {
		const { addDateCallback } = this.props;
		const selectedDate = getUtcString(date);

		addDateCallback(FormSettings.OPEN_SCHEDULE, selectedDate);
	};

	// Show/hide date section.
	toggleDate = (evt) => {
		const { addDateCallback,
			schedule,
			removeDateCallback
		} = this.props;

		if (evt.target.checked) {
			addDateCallback(FormSettings.OPEN_SCHEDULE, schedule);
		} else {
			removeDateCallback(FormSettings.OPEN_SCHEDULE);
		}
	};
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/advanced-settings/components/sections/open-date.js